import { Link } from "react-router-dom";
import HeroBreadcrumb from "@/components/layout/HeroBreadcrumb";
import { ArrowRight, Mail, Phone } from "lucide-react";

export default function FlessibilitaOrganizzativaPage() {
  return (
    <main id="main-content" data-testid="flessibilita-page">

      {/* Hero */}
      <section className="relative h-[280px] md:h-[340px] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920&q=60&auto=format"
          alt="Flessibilità organizzativa"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(4, 30, 66, 0.82)" }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative h-full flex flex-col justify-end pb-10">
          <HeroBreadcrumb />
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">
            Area Lavoro e Welfare
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mt-2 font-['Encode_Sans_Semi_Condensed'] tracking-tight">
            Flessibilità organizzativa
          </h1>
        </div>
      </section>

      {/* Contenuto */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <h2 className="text-2xl md:text-3xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] leading-snug mb-8">
            Flessibilità organizzativa con il supporto di Confcommercio Roma: la tua scelta agile!
          </h2>

          <div className="space-y-6 text-[var(--confcom-text-secondary)] leading-relaxed text-base">
            <p>
              Vuoi attrarre talenti ed essere competitivo e all'avanguardia sull'organizzazione del lavoro? Confcommercio Roma ha la soluzione per te!
            </p>

            <p>
              Con lo smart working, disciplinato dalla <strong className="text-[var(--confcom-text-primary)]">legge n. 81/2017</strong>, puoi incrementare la tua competitività e facilitare la <strong className="text-[var(--confcom-text-primary)]">conciliazione</strong> dei tempi di vita e di lavoro delle tue risorse, consentendo lo svolgimento della <strong className="text-[var(--confcom-text-primary)]">prestazione lavorativa</strong> anche all'esterno dell'azienda e senza una postazione fissa.
            </p>

            <p>
              Confcommercio Roma offre <strong className="text-[var(--confcom-text-primary)]">supporto alle imprese</strong> con un'assistenza all'azienda a 360° sugli aspetti: normativi e contrattuali, sicurezza sul lavoro, utilizzo degli strumenti di lavoro e diritto alla disconnessione, controllo a distanza e comunicazioni obbligatorie.
            </p>

            <p>
              Inoltre, le imprese possono entrare in contatto con i partner di Confcommercio Roma che progettano la <strong className="text-[var(--confcom-text-primary)]">rivisitazione e riorganizzazione</strong> degli spazi aziendali nell'ambito dello smart working, con il contestuale svolgimento di corsi formativi del personale interessato. Tramite <strong className="text-[var(--confcom-text-primary)]">Ebit Lazio</strong>, le aziende interessate potranno anche accedere alla formazione gratuita sui temi del lavoro agile.
            </p>

            <p>
              Oltre allo smart working, Confcommercio Roma promuove ulteriori forme di flessibilità organizzativa. Tra queste, il <strong className="text-[var(--confcom-text-primary)]">Contratto Integrativo Regionale del Terziario</strong>, firmato da Confcommercio Roma, prevede la flessibilità oraria settimanale con la possibilità di riduzione dell'orario fino a 36 ore settimanali e l'assorbimento dei permessi per un periodo nell'anno massimo di 18 settimane. Queste misure consentono alle imprese di migliorare la <strong className="text-[var(--confcom-text-primary)]">gestione del personale</strong> e ai lavoratori di conciliare meglio vita privata e professionale.
            </p>
          </div>

        </div>
      </section>

      {/* CTA */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="/cta-background.jpg" alt="" className="w-full h-full object-cover" aria-hidden="true" />
          <div className="absolute inset-0" style={{ backgroundColor: "rgba(0, 59, 117, 0.88)" }} />
        </div>
        <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#56B7E6] font-['Encode_Sans_Semi_Condensed']">Per maggiori informazioni</span>
          <h2 className="text-3xl md:text-4xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight mt-3 mb-8">Contattaci</h2>

          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 text-left" data-testid="flessibilita-organizzativa-contatti">
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2 text-white/80">
                <Mail size={14} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                <a href="mailto:sindacale@confcommercioroma.it" className="hover:text-white transition-colors">sindacale@confcommercioroma.it</a>
              </div>
              <div className="flex items-center gap-2 text-white/80">
                <Phone size={14} className="text-[#56B7E6] shrink-0" aria-hidden="true" />
                <a href="tel:+390668437221" className="hover:text-white transition-colors">Tel: 06 68437 221-290</a>
              </div>
            </div>
          </div>

          <Link
            to="/chi-siamo/struttura-tecnica#ufficio-lavoro-e-welfare"
            data-testid="flessibilita-organizzativa-scopri-team"
            className="inline-flex items-center gap-2 bg-white text-[var(--confcom-blue)] px-6 py-3 rounded-md font-semibold hover:bg-white/90 transition-colors text-sm mt-8"
          >
            Scopri il Team <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>
      </section>

    </main>
  );
}
